// import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { Year } from "../../types";

const UserHistory = () => {
    const [, setYears] = useState<Year[]>([]);

    useEffect(() => {
        const fetchYears = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_PATH}/api/year`);
                const data: Year[] = await response.json();
                // Sort years in descending order
                const sortedYears = data.sort((a, b) => b.year - a.year);
                setYears(sortedYears);
            } catch (error) {
                console.error('Error fetching years:', error);
            }
        };
        fetchYears();
    }, []);

    return (
        <>
            {/* Year Navigation Bar */}
            <div className="w-full bg-white border-b border-borders">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="flex justify-center items-center gap-8 py-4 flex-wrap">
                        {/* {years.map(yearData => (
                            <Link 
                                key={yearData.year}
                                to={`/history/${yearData.year}`} 
                                className="text-lg hover:text-accent transition-colors"
                            >
                                {yearData.year}
                            </Link>
                        ))} */}
                    </div>
                </div>
            </div>

            {/* Sub Navigation Bar - Placeholder */}
            <div className="w-full bg-gray-100 border-b border-borders">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="flex justify-center items-center gap-8 py-3">
                        <span className="text-base text-gray-400">Výsledky</span>
                        <span className="text-base text-gray-400">Štatistiky</span>
                        <span className="text-base text-gray-400">Zápasy</span>
                        <span className="text-base text-gray-400">Tímy</span>
                    </div>
                </div>
            </div>

            <div className="w-[90vw] md:w-[70vw] xl:w-[46vw] mx-auto mt-12">
                {/* <p className="text-center text-gray-600">Vyberte rok zo zoznamu vyššie</p> */}
            </div>
        </>
    );
};

export default UserHistory;
